<template>
  <div>
    <div>
      <Navbar />
      <HeaderComparate />
    </div>

    <div>
      <Contents />
    </div>

    <div>
      <Footer />
    </div>
  </div>
</template>

<script>
import Navbar from "../../components/layout/Navbar";
import Contents from "./components/Contents.vue";
import HeaderComparate from "../../components/cabecera/HeaderComparate.vue";
import Footer from "../../components/layout/Footer.vue";
export default {
  components: {
    Navbar,
    Contents,
    HeaderComparate,
    Footer,
  },
  mounted() {
    this.$store.commit("setSelectedMainView", "comparator");
  }
};
</script>
